import React, { createContext, useContext, useState } from 'react';

const HeaderContext = createContext(null);

export const HeaderProvider = ({ children }) => {
  const [mobileHeaderHidden, setMobileHeaderHidden] = useState(false);
  
  return (
    <HeaderContext.Provider value={{ mobileHeaderHidden, setMobileHeaderHidden }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  // Return default values if no provider (for safety)
  if (!context) {
    return { mobileHeaderHidden: false, setMobileHeaderHidden: () => {} };
  }
  return context;
};
